import Helper from "../../Helper";
import { Material } from "../../models/Material";
import { Order } from "../../models/Order";
import { ChangeHistoryMessage } from "../Materials/materialTypes";

function getCommentableType(commentable: Order | Material): string {
    let commentableType: string;
    switch (true) {
        case commentable instanceof Order:
            commentableType = "Order";
            break;
        case commentable instanceof Material:
            commentableType = "Material";
            break;
        default:
            throw new Error("Unknown commentable type");
    }
    return commentableType;
}

export function createComment(
    project: any,
    comment: string,
    commentable: Order | Material,
    files: File[]
): Promise<any> {
    const url = `${Helper.baseUrlAltSubdomain(project.claimed_by_team_subdomain)}/projects/${
        project.unique_token
    }/comments`;

    const formData = new FormData();
    formData.append("body", comment);
    formData.append("commentable_type", getCommentableType(commentable));
    formData.append("commentable_id", commentable.id.toString());

    files.forEach((file) => {
        formData.append("files[]", file, file.name);
    });
    const options = {
        method: "post",
        body: formData,
    };
    return Helper.plotFetch(url, options, true)
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })
        .then((data) => {
            return Promise.resolve(data);
        })
        .catch(() => {
            return Promise.reject();
        });
}

export function getComments(project: any, commentable: Order | Material): Promise<ChangeHistoryMessage[]> {
    const url = `${Helper.baseUrlAltSubdomain(project.claimed_by_team_subdomain)}/projects/${
        project.unique_token
    }/comments?commentable_type=${getCommentableType(commentable)}&commentable_id=${commentable.id}`;

    return Helper.plotFetch(url, {}, true)
        .then((data) => {
            if (data.ok) {
                return data.json();
            }
            throw new Error("Network error.");
        })

        .then((data) => {
            return data.map((message: any) => ChangeHistoryMessage.fromApiObject(message));
        })
        .catch(() => {
            return [];
        });
}
